import { usePost } from "./api";
import { publish } from "../../pubSub";

import getApiUrl from "../../getApiUrl";

const apiUrl = getApiUrl();

function useRedirectToInvoiceSchedule(scheduleId) {
  const process = usePost();
  var d = new Date();
  let fileName = `${scheduleId}-${d.toUTCString()}`;

  async function handleSubmit() {
    const result = await process(`documents/sign-request-schedule/${scheduleId}`);

    if (result?.isSuccess) {
      var { token, fileName } = result.value;

      window.location = `${apiUrl}/invoicing/documents/${scheduleId}/view-schedule/${fileName}?token=${token}`;
    } else {
      publish("notification", `Error - could not open Schedule.`);
    }
  }

  return handleSubmit;
}

export default useRedirectToInvoiceSchedule;
